import React, { useEffect, useState } from 'react';
import './index.css'; // Custom styles and animations
import logoSrc from './img/logo.png';
import { FaInstagram, FaFacebook, FaLinkedin, FaTwitter } from 'react-icons/fa'; // Social media icons

const Footer = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Animate footer visibility on render
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 100);
    return () => clearTimeout(timer); // Cleanup timeout
  }, []);

  return (
    
    <footer id='footerElements' className={`Footer ${isVisible ? 'fade-in' : ''}`}>
      <div className="footer-grid" >
        {/* Logo Section */}
        <div className="grid-column logo-section1">
          {logoSrc && <img src={logoSrc} alt="Shigjeta Logo" />}
          <p className='logop'>We Generate Solutions</p>
        </div>

        {/* Services */}
        <div className="grid-column">
    <h4>Main Services</h4>
    <ul>
        <li><a href="/branding">Branding</a></li>
        <li><a href="/marketing">Marketing</a></li>
        <li><a href="/web-development">Web Development</a></li>
        <li><a href="/app-development">App Development</a></li>
        <li><a href="/photography-video">Photography & Video</a></li>
        <li><a href="/animations">Animations</a></li>
        <li><a href="/print">Print</a></li>
    </ul>
</div>

<div className="grid-column">
    <h4>Premium Services</h4>
    <ul>
        <li><a href="/business">Business Market Statistics</a></li>
        <li><a href="/platform-designing">Platform Designing</a></li>
        <li><a href="/project-development">Project Development</a></li>
        <li><a href="/education-support">Education Support</a></li>
        <li><a href="/team-training">Team Training</a></li>
        <li><a href="/organizational-missions">Organizational Missions</a></li>
    </ul>
</div>

<div className="grid-column">
    <h4>Third-Party Services</h4>
    <ul>
        <li><a href="/mentoring">Mentoring</a></li>
        <li><a href="/consulting">Consulting</a></li>
        <li><a href="/financial-services">Financial Services</a></li>
    </ul>
</div>

{/* About Us */}
<div className="grid-column">
    <h4>About Us</h4>
    <ul>
        <li><a href="/more-about-us">More about us</a></li>
        <li><a href="/projects">Projects</a></li>
        <li><a href="/find-our-office">Find our office / Resources</a></li>
        <li><a href="/follow-us">Follow us on Social Media</a></li>
        <li><a href="/shigjeta-shop">Shigjeta Shop</a></li>
        <li><a href="/cv">CV of Staff</a></li>
    </ul>
</div>

{/* Sales */}
<div className="grid-column">
    <h4>Sales</h4>
    <ul>
        <li><a href="/become-agent">Become a Sales Agent</a></li>
        <li><a href="/sales-agent-formular">Sales Agent Formular</a></li>
        <li><a href="/chambers-shigjeta">Chambers of Shigjeta</a></li>
        <li><a href="/chamber-formular">Chamber Formular</a></li>
    </ul>
</div>

{/* Contracting */}
<div className="grid-column">
    <h4>Contracting</h4>
    <ul>
        <li><a href="/terms-condition">Terms and Conditions</a></li>
        <li><a href="/formular-contract">Formular for Contract</a></li>
        <li><a href="/privacy-policy">Privacy and Policy</a></li>
        <li><a href="/Jobapplication">Job Aplication Form</a></li>
       

    </ul>
</div>

{/* Blogs */}
<div className="grid-column">
    <h4>Blog</h4>
    <ul>
        <li><a href="/blog">Research</a></li>
        <li><a href="/blog">How to</a></li>
        <li><a href="/blog">Stories behind our journey</a></li>
    </ul>
</div>

{/* Outsourcing */}
<div className="grid-column">
    <h4>Outsourcing</h4>
    <ul>
        <li><a href="/outsourcing">Why in Kacanik Kosovo</a></li>
        <li><a href="/outsourcing">Talent Finding</a></li>
    </ul>
</div>

{/* Collaborations */}
<div className="grid-column">
    <h4>Collaborations</h4>
    <ul>
        <li><a href="/collaborations">Active Collaborations</a></li>
        <li><a href="/collaborations">Potential Collaborations</a></li>
    </ul>
</div>

{/* Investments */}
<div className="grid-column">
    <h4>Investments</h4>
    <ul>
        <li><a href="/investment">Invest on MVP-s</a></li>
        <li><a href="/InvestIdea">Invest in your idea</a></li>
    </ul>
</div>
<div className="grid-column">
    <h4>EDUCATION</h4>
    <ul>
    <li><a href="/ShigjetaAcademyForm">Shigjeta Academy Form</a></li>
    </ul>
</div>


      </div>

      {/* Footer Bottom Section */}
      <div className="footer-bottom">
        <p>&copy; 2024 SHIGJETA LLC. All rights reserved.</p>
      </div>
    </footer>      

  );
};

export default Footer;
